let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1IaDy")).then(() => parcelRequire('5Etd3'));